import { useStyles } from "../styles";
import Avatar from "@mui/material/Avatar";
import UserIcon from "../../../assets/header/user.png";
import { MenuButtonHeader } from "../../../components/MenuButtonHeader";
import { useCallback, useState } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import ProfileMenu from "../ProfileMenu";

export function RightHeader() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const styles = useStyles();
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] =
    useState<HTMLElement | null>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) =>
    setProfileMenuAnchorEl(event.currentTarget);
  const handleProfileMenuClose = () => setProfileMenuAnchorEl(null);

  const handleSignOut = useCallback(() => {
    signOut();
    navigate("/");
  }, [navigate, signOut]);

  return (
    <div className={styles.rootLeft} id="header-block-right">
      <MenuButtonHeader
        id="btn-apps"
        className={styles.btn}
        variant="outlined"
        label="Campanhas"
        options={[
          {
            label: "Disparo em canais digitais",
            onClick: () => navigate("campaign"),
          },
          {
            label: "Descontos personalizados",
            onClick: () => navigate("offers"),
          },
          {
            label: "Ações premiadas",
            onClick: () => navigate("campaign-awarded"),
          },
        ]}
      />

      <MenuButtonHeader
        id="btn-apps"
        className={styles.btn}
        variant="contained"
        label="Criar campanha"
        options={[
          {
            label: "Criar disparo em canais digitais",
            onClick: () => navigate("create-campaign"),
          },
          {
            label: "Criar descontos personalizados",
            onClick: () =>
              navigate({
                pathname: "offers",
                search: createSearchParams({
                  create: "offer",
                }).toString(),
              }),
          },
          {
            label: "Criar ação premiada",
            onClick: () =>
              navigate({
                pathname: "campaign-awarded",
                search: createSearchParams({
                  create: "awarded",
                }).toString(),
              }),
          },
        ]}
      />

      <Avatar
        id="avatar"
        className={styles.avatar}
        src={UserIcon}
        onClick={handleProfileMenuOpen}
      />

      <ProfileMenu
        anchorEl={profileMenuAnchorEl}
        onClose={handleProfileMenuClose}
        handleSignOut={handleSignOut}
      />
    </div>
  );
}
